import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-order-fulfill",
  "use": "icon-soc-mall-order-fulfill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-order-fulfill\">\n<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n  <rect x=\"160\" y=\"280\" width=\"420\" height=\"320\" rx=\"36\" />\n  <path d=\"M580 360h200l84 120v120H580\" />\n  <circle cx=\"320\" cy=\"680\" r=\"56\" />\n  <circle cx=\"720\" cy=\"680\" r=\"56\" />\n  <path d=\"M280 440h200\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-order-fulfill.svg
// module id = 0fhf
// module chunks = 546